import "./caso.css";
import { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { formatContent } from "../../utils/formatText";
import casos from "../../componentes/Caso/casos";
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import Buttons from "../../componentes/Buttons/Buttons";
import Pills from "../../componentes/pills/Pills";
import { conProyectosImg } from "../../conexiones/varConexiones";
import textCasos from "./dictionary.js";

const Caso = ({scroll}) => {
    const { id } = useParams();
    const caso = Object.values(casos).filter(c => c.id===id)
    const lang = useSelector((state) => state.lang.lang);
    const [estadoModal,cambiaEstadoModal] = useState({type:null,on:false,id:null,scroll:true});

    function scrollingWindows (){
        if(estadoModal.scroll === true){
        return window.scrollY > 0 ? window.scroll({top: 0,behavior: "smooth"}):null;
        }
    }
    useEffect(()=>{
        scrollingWindows()
    })
    return (
        <div className="caso">
            <div className="caso-main">
                <div className="caso-header">
                    <p className="caso-header-rotulo">Caso</p>                
                    <h2 className="caso-header-title">{caso[0][lang].proyecto}</h2>
                    <h5 className="caso-header-bajada">{caso[0][lang].descripcion}</h5>
                    <div className="caso-header-skills">
                        {caso[0].skills.map(
                            (skill)=> <Pills key={skill} type={'outlined'} color={'white'} text={skill} icon={''}></Pills>
                        )}
                    </div>
                </div>
                <div className="devider h"></div>
                <div className="caso-cuerpo">
                    <div className="caso-cuerpo-section">
                      <h4>{textCasos.contexto[lang]}</h4>
                        {formatContent(caso[0][lang].contexto)}  
                    </div>
                    {caso[0].imgs.portada? <div style={{backgroundImage:`url(${conProyectosImg}/${id}/${caso[0].imgs.portada}.jpg)`}} className="caso-cuerpo-image"></div>:''}
                    <div className="caso-cuerpo-section">
                        <h4>{textCasos.investigacion[lang]}</h4>
                        {formatContent(caso[0][lang].Investigacion)}
                    </div>
                    <div className="caso-cuerpo-section">
                        <h4>{textCasos.solucion[lang]}</h4>
                        {formatContent(caso[0][lang].solucion)}
                    </div>
                    {caso[0].imgs.solucion?
                        <div className="caso-cuerpo-img-solucion">
                            {caso[0].imgs.solucion.map((img)=><div style={{backgroundImage:`url(${conProyectosImg}${id}/${img}.jpg)`}} className="caso-cuerpo-image"></div>)}
                        </div>:''
                    }
                    <div className="caso-cuerpo-section">
                        <h4>{textCasos.aprendizajes[lang]}</h4>
                        {formatContent(caso[0][lang].aprendizajes)}
                    </div>
                </div>
                <div className="caso-back">
                        <Link className='Link' to="/Home">
                            <Buttons type={'primary'} onClick={scroll} cta={'Volver'}></Buttons>
                        </Link>
                </div>
            </div>
        </div>
    )
}

export default Caso;